import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";
import { formatToCommaSeparatedString } from "utils/HelperFunctions";

interface IProps {
  purchaseData: PurchaseData | null;
  handleAcceptPurchase: () => void;
  handleDeclinePurchase: () => void;
}
function PaymentBreakdownModal({ purchaseData, handleAcceptPurchase, handleDeclinePurchase }: IProps) {
  return (
    <Modal open={!!purchaseData} onClose={handleDeclinePurchase}>
      <div className="relative w-[90vw] rounded-2xl bg-primary p-4 text-white shadow-modal md:max-w-[600px] md:p-8">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-sm font-bold leading-tight md:text-2xl">Confirm Purchase?</h1>
          </div>

          <span
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={handleDeclinePurchase}
            className="cursor-pointer"
          >
            <CloseIcon className="h-4 w-4 text-white" />
          </span>
        </div>
        <section className="mt-3 grid w-full grid-cols-2 font-satoshi text-sm font-450 leading-snug text-white">
          <div className="space-y-1">
            <div className="aspect-1 w-full overflow-hidden rounded-xl pb-3 pr-4 pt-1 opacity-90">
              {purchaseData?.magnetImageUrl && (
                <img className="rounded-xl" src={purchaseData.magnetImageUrl} alt="Magnet" />
              )}
            </div>
          </div>
          <div className="flex flex-col justify-between">
            <div>
              <div className="text-lg font-bold opacity-90">{purchaseData?.magnetName}</div>
              <h5 className="text-xs font-semibold">Description:</h5>
              <p
                className="line-clamp-2 text-xxs leading-tight opacity-70 md:line-clamp-5"
                title={purchaseData?.magnetDescription}
              >
                {purchaseData?.magnetDescription}
              </p>
            </div>
            <div className="pt-3">
              <h3 className="text-lg font-bold">Payment Details</h3>
              <div className="grid grid-cols-2 text-xxs leading-relaxed">
                <div className="">Magnet Price:</div>
                <div className="pl-3 font-semibold opacity-80">
                  {formatToCommaSeparatedString(parseFloat(purchaseData?.paymentBreakDown.baseFee || "0"), "currency")}
                </div>
                <div className="">Service Fee:</div>
                <div className="pl-3 font-semibold opacity-80">
                  {formatToCommaSeparatedString(
                    parseFloat(purchaseData?.paymentBreakDown.serviceFee || "0"),
                    "currency",
                  )}
                </div>
                <div className="underline">Total:</div>
                <div className="pl-3 font-semibold opacity-80">
                  {formatToCommaSeparatedString(parseFloat(purchaseData?.paymentBreakDown.totalFee || "0"), "currency")}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="mt-10 flex justify-end gap-3">
          <Button
            variant="whiteOutline"
            text="CANCEL"
            onClick={handleDeclinePurchase}
            additionalClasses="!text-base !px-3 !py-1.5"
          />
          <Button
            variant="magnetiqSolid"
            text="PURCHASE"
            onClick={handleAcceptPurchase}
            additionalClasses="!text-base !px-3 !py-1.5 !md:text-xxs !md:px-3 md:!py-2"
          />
        </div>
      </div>
    </Modal>
  );
}

export default PaymentBreakdownModal;
